import { useMutation, useQuery } from '@tanstack/react-query'
import { api } from '@/shared/lib/api'
import type { Plan, PlanTriggered } from '@/shared/data/system-integrations.types'

const plannerCall = <T>(toolName: string, params: Record<string, unknown>) =>
  api.post<{ result: T }>('/api/agents/tool-call', { agentType: 'planner', toolName, params })

/** Trigger plan — returns plan_id immediately, result via SSE event */
export function useTriggerPlan() {
  return useMutation({
    mutationFn: (params: { requestText: string; productContext?: string; planType?: string }) =>
      plannerCall<PlanTriggered>('planner.trigger_plan', {
        request_text: params.requestText,
        product_context: params.productContext,
        plan_type: params.planType ?? 'feature',
      }),
  })
}

export function useListPlans() {
  return useQuery({
    queryKey: ['planner', 'plans'],
    queryFn: () => plannerCall<Plan[]>('planner.list_plans', {}),
    refetchInterval: 30_000,
  })
}

export function useGetPlan(planId: string) {
  return useQuery({
    queryKey: ['planner', 'plan', planId],
    queryFn: () => plannerCall<Plan>('planner.get_plan_result', { plan_id: planId }),
    enabled: !!planId,
  })
}

export function useCancelPlan() {
  return useMutation({
    mutationFn: (planId: string) => plannerCall<void>('planner.cancel_plan', { plan_id: planId }),
  })
}
